<template>
  <div class="index-wrap">
    <back-button />
    <IndexHeader :user="user" />
    <div class="index-label">
      <img :src="require('@/assets/img/label-icon.png')" />
      <img class="time-icon" :src="require('@/assets/img/time-icon.png')" />
      <img class="sub-icon" :src="require('@/assets/img/sub-title-icon.png')" />
    </div>
    <div class="menu-wrap">
      <div class="competition-item bg-4" @click="goCompetition()"></div>
      <div class="competition-item bg-5" @click="goVersus()"></div>
    </div>
  </div>
</template>
<script>
import BackButton from "@/components/BackButton.vue";
import IndexHeader from "@/components/IndexHeader.vue";
export default {
  components: {
    BackButton,
    IndexHeader,
  },
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
  methods: {
    goCompetition() {
      if (new Date().getTime() < 1779033600000) {
        this.$notify({
          type: "danger",
          message: "活动未开始",
          duration: 2000,
        });
      } else {
        this.$router.push("/question");
      }
    },
    goVersus() {
      if (new Date().getTime() < 1779033600000) {
        this.$notify({
          type: "danger",
          message: "活动未开始",
          duration: 2000,
        });
      } else {
        this.$router.push("/versus/index");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.index-wrap {
  @include index-bg;

  position: relative;
  .index-label {
    margin-top: 82px;
    text-align: center;
    img {
      width: 100%;
      vertical-align: top;
    }
    .time-icon {
      width: 216px;
    }
    .sub-icon {
      width: 262px;
    }
  }

  .menu-wrap {
    display: flex;
    justify-content: space-between;
    padding: 0 63px 0;
    .competition-item {
      width: 100px;
      height: 100px;
      margin-top: 10px;
      cursor: pointer;
    }

    @for $i from 4 through 5 {
      .bg-#{$i} {
        background: url("~@/assets/img/bg-#{$i}.png") no-repeat top center/100%;
      }
    }
  }
}
</style>
